import { graphql } from '@apollo/client/react/hoc';
import * as compose from 'lodash.flowright';
import { withTranslation } from 'react-i18next';
import { UserByInvitationCode } from 'graphqlDocuments/queries';
import setAndroidReferrer from 'utils/setAndroidReferrer';
import getValidatedParams from 'utils/getValidatedParams';
import { codeOrUsername } from 'utils/schemaUtils';

export const extractCode = (match) => {
  const { params } = match;
  const { code } = getValidatedParams({
    params,
    schema: { code: codeOrUsername },
  });
  return code;
};

const InvitationContainer = (Invitation) =>
  compose(
    withTranslation('REFERRALS'),
    graphql(UserByInvitationCode, {
      options: ({ match }) => {
        const code = extractCode(match);
        if (code) {
          setAndroidReferrer('referralCode', code);
        }
        return {
          variables: { code },
        };
      },
      props: ({ data }) => ({
        loading: data.loading,
        referrerEmail: data.user?.email || null,
        matchingPeer: {
          id: data.user?.id,
          name: data.user?.username,
        },
      }),
      skip: ({ match }) => !extractCode(match),
    }),
  )(Invitation);

export default InvitationContainer;
